import { useTranslation } from "react-i18next";
import { CaretUp, CaretDown, PencilSimple } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import { truncateText } from "./utils";
import type { FaqItem } from "@/types/faq";

export function FaqItemRow({
  item,
  index,
  total,
  onEdit,
  onMoveUp,
  onMoveDown,
}: {
  item: FaqItem;
  index: number;
  total: number;
  onEdit: () => void;
  onMoveUp: () => void;
  onMoveDown: () => void;
}) {
  const { t } = useTranslation();

  return (
    <li
      className={cn(
        "flex items-center gap-2 px-3 py-3 sm:gap-3 sm:px-4",
        "transition-colors hover:bg-muted/30",
      )}
    >
      <button
        type="button"
        onClick={onEdit}
        className="min-w-0 flex-1 text-left"
      >
        <div className="flex flex-wrap items-center gap-2">
          <p className="text-sm font-medium text-foreground">{item.questionBs}</p>
          {!item.isActive && (
            <span className="rounded-full bg-muted px-2 py-0.5 text-[10px] font-medium text-muted-foreground">
              {t("faqAdmin.inactive")}
            </span>
          )}
        </div>
        <p className="mt-0.5 truncate text-xs text-muted-foreground">{item.questionEn}</p>
        <p className="mt-1 line-clamp-1 text-xs text-muted-foreground/70">
          {truncateText(item.answerBs, 140)}
        </p>
      </button>

      <div className="flex shrink-0 items-center gap-0.5">
        <button
          type="button"
          title={t("faqAdmin.moveUp")}
          disabled={index === 0}
          onClick={onMoveUp}
          className="rounded-lg p-2 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground disabled:opacity-30"
        >
          <CaretUp className="size-4" />
        </button>
        <button
          type="button"
          title={t("faqAdmin.moveDown")}
          disabled={index >= total - 1}
          onClick={onMoveDown}
          className="rounded-lg p-2 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground disabled:opacity-30"
        >
          <CaretDown className="size-4" />
        </button>
        <button
          type="button"
          title={t("faqAdmin.edit")}
          onClick={onEdit}
          className="rounded-lg p-2 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
        >
          <PencilSimple className="size-4" />
        </button>
      </div>
    </li>
  );
}
